import { HttpClientModule } from '@angular/common/http';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { ApiInterceptor } from '../services/api-interceptor.service';
import { ApiService } from '../services/api.service';


@NgModule({
    imports: [
        HttpClientModule,
        ApiInterceptor
    ],
    exports: [
        ApiInterceptor
    ]
})
export class ApiModule {
    static forRoot(): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [
                ApiService
            ]
        };
    }
}
